export default [
    { edProfession: "ADVERTISING AGENCIES" },
    {
        edProfession: "AGRICULTURE & ALLIED ACTIVITIES",
    },
    { edProfession: "AIRLINES" },
    { edProfession: "ARCHITECT" },
    { edProfession: "ARMED FORCES" },
    {
        edProfession: "ARTIST/DANCE/MUSIC TEACHER",
    },
    {
        edProfession: "AUTO REPAIRS SERVICE GARAGES",
    },
    {
        edProfession: "BEAUTY PARLOUR & CRECHES",
    },
    {
        edProfession: "BEVERAGES/FOOD PROCESSING",
    },
    { edProfession: "BUILDING & CONSTRUCTION" },
    { edProfession: "CABLE TV NETWORK" },
    { edProfession: "CARGO/VESSEL SERVICES" },
    {
        edProfession: "CARPET CLOTH WEAVING MFG",
    },
    { edProfession: "CHARTERED ACCOUNTANTS" },
    {
        edProfession: "CHEMICAL/DRUGS/PHARMACEUTICALS",
    },
    { edProfession: "CIVIL/FOREIGN SERVICE" },
    {
        edProfession: "CLEARING AND FORWARDING AGENT",
    },
    { edProfession: "COLLECTION SERVICES" },
    { edProfession: "CONSULTANT" },
    { edProfession: "CONTRACTORS" },
    {
        edProfession: "COTTON TEXTILE/SPINNING WEAVING DYE",
    },
    { edProfession: "CS/ICWA" },
    { edProfession: "CYBER CAFES" },
    {
        edProfession: "DAILY /GOVT SCHEME WAGERS",
    },
    { edProfession: "DAIRY PRODUCTS -MFG" },
    { edProfession: "DOCTORS" },
    { edProfession: "EDUCATION" },
    { edProfession: "ELECTRICAL/ELECTRONICS" },
    { edProfession: "ENERGY & RESOURCES" },
    { edProfession: "ENGINEERING" },
    {
        edProfession: "EQUIPMENT RENTAL & LEASING",
    },
    { edProfession: "EX-SERVICEMAN" },
    { edProfession: "FARMERS" },
    { edProfession: "FERTILIZERS & CHEMICALS" },
    {
        edProfession: "FILM & THEATRE/ENTERTAINMENT/MEDIA",
    },
    {
        edProfession: "FILM EXHIBITOR/DISTRIBUTOR",
    },
    { edProfession: "FINANCIAL SERVICES" },
    { edProfession: "FLOURIST/GIFT GALLERY" },
    {
        edProfession: "FOOD & AGRO PROCESSING SECTOR",
    },
    {
        edProfession: "FREIGHT /CONTAINER MOVEMENT",
    },
    { edProfession: "FURNITURE N.E.C. MFG" },
    { edProfession: "GENERAL BUILDER" },
    { edProfession: "GENERAL MANUFACTURER" },
    {
        edProfession: "GENERAL SERVICE PROVIDER",
    },
    { edProfession: "GENERAL TRADER" },
    { edProfession: "GOLDSMITH" },
    {
        edProfession: "GOVERNMENTS - CENTRAL & STATE",
    },
    { edProfession: "HAND TOOLS TRADER/MANUF" },
    { edProfession: "HANDICRAFTS/DESIGNING" },
    {
        edProfession: "HANDLOOM TEXTILE & KHADI/SPIN WEAVE",
    },
    { edProfession: "HEALTH CARE SERVICES" },
    { edProfession: "HOME BASED BUSINESS" },
    { edProfession: "HOTELS & RESTAURANTS" },
    {
        edProfession: "INDUSTRIAL CONSULTANCY PHOTOGRAPHY",
    },
    {
        edProfession: "INTERNET BROWSING/CYBER CAFE",
    },
    { edProfession: "IRON & STEEL" },
    {
        edProfession: "JEWELLERY AND RELATED ACTIVITIES",
    },
    { edProfession: "JOURNALISTS" },
    { edProfession: "JUTE AND MESTA" },
    { edProfession: "KANDIL/KITE MFG" },
    {
        edProfession: "KHADI & VILLAGE INDUSTRIES",
    },
    {
        edProfession: "LAND TRANSPORT-PVT TRANSPORT COS",
    },
    { edProfession: "LAUNDRY & DRY CLEANING" },
    { edProfession: "LAWYER" },
    {
        edProfession: "LEASING RENTING & BUSINESS ACT",
    },
    { edProfession: "LIC Agent" },
    { edProfession: "LPG/CNG DISTRIBUTORS" },
    { edProfession: "MARKETING CONSULTANCY" },
    { edProfession: "MERCHANT NAVY" },
    { edProfession: "MFG OF ICE" },
    { edProfession: "MFG OF PLASTIC PROCESS." },
    { edProfession: "MFR OF STATUES" },
    { edProfession: "OIL & GAS/PETROLEUM" },
    {
        edProfession: "PAINTS VARNISHES LACQUERS POLISHES",
    },
    { edProfession: "PAPAD MAKING" },
    { edProfession: "PENSIONER" },
    {
        edProfession: "PERFUMES COSMETICS TOILETERIES",
    },
    { edProfession: "PHARMA" },
    {
        edProfession: "PHOTO LABS & STUDIOS / X RAY CLINIC",
    },
    { edProfession: "PHOTOCOPYING CENTRES" },
    {
        edProfession: "PLASTIC PRODUCT/MOULDED CONTAINER",
    },
    { edProfession: "POLICE" },
    { edProfession: "POWER & ENERGY" },
    { edProfession: "PRIVATE RETAIL TRADERS" },
    { edProfession: "PROFESSIONALS" },
    { edProfession: "PROPERTY DEALER/BROKER" },
    { edProfession: "RAILWAYS" },
    { edProfession: "REAL ESTATE" },
    {
        edProfession: "RENTAL INCOME/LANDLORD/PG ACCO",
    },
    {
        edProfession: "ROAD/WATER TRANSPORT OPERATORS",
    },
    { edProfession: "SHIPPING" },
    { edProfession: "SOFT TOYS - MFG" },
    { edProfession: "SOFTWARE INDUSTRY" },
    { edProfession: "SPICES/PICKLE/PAPAD MFG" },
    {
        edProfession: "SPORTS AND ATHLETIC GOODS",
    },
    { edProfession: "STATIONERY/PUBLISHING" },
    {
        edProfession: "STD/ISD BOOTHS PRINTERS/FAX SERVICES",
    },
    { edProfession: "STEEL TRADING/MANUF." },
    { edProfession: "STOCK BROKER" },
    {
        edProfession: "SUGAR FACTORIES MANUF AND REFINING",
    },
    { edProfession: "TAILORING" },
    { edProfession: "TELECOMMUNICATIONS" },
    { edProfession: "TEXTILES & GARMENTS" },
    { edProfession: "TOURS & TRAVELS" },
    {
        edProfession: "TRANSPORTSTORAGE & COMMUNICATIONS",
    },
    { edProfession: "TRANSPORTATION" },
    {
        edProfession: "TYPING/XEROXING/DTP CENTRES",
    },
    {
        edProfession: "VEG/FRUIT/MEAT/FISH/TEA VENDING",
    },
    { edProfession: "WAGE WORKER" },
    { edProfession: "X-RAY CLINICS" },
    { edProfession: "OTHERS" },
];
